import { Components, Theme } from "@mui/material";

declare module "@mui/material/Paper" {
  interface PaperPropsVariantOverrides {
    LinkBox: true;
    LinkList: true;
    PaperCard: true;
    nestedListAccordion: true;
    AbsenceBalanceStatus: true;
  }
}

const globalPaperPadding = {
  padding: "2rem",
};

export const MuiPaper: Components<Theme>["MuiPaper"] = {
  defaultProps: {
    elevation: 4,
  },
  variants: [
    {
      props: { elevation: 4 },
      style: {
        borderRadius: "1rem",
        boxShadow:
          "0px 4px 24px 0px rgba(166, 166, 166, 0.20), 0px 1px 1px 0px #F2F2F2, 0px 2px 4px -1px rgba(242, 242, 242, 0.20)",
      },
    },
    {
      props: { variant: "LinkBox" },
      style: () => ({
        minHeight: "350px",
        display: "flex",
        flexDirection: "column",
        ...globalPaperPadding,
      }),
    },
    {
      props: { variant: "LinkList" },
      style: () => ({
        ...globalPaperPadding,
        marginBottom: "2rem",
      }),
    },
    {
      props: { variant: "PaperCard" },
      style: () => ({
        display: "flex",
        flexDirection: "column",
        marginBottom: "2rem",
        gap: 1.5,
        ...globalPaperPadding,
      }),
    },
  ],
};
